// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-card {
  padding: 10px !important;
}
.main-card h5 {
  padding-left: 5px !important;
  font-size: 15px !important;
  text-align: start;
  font-weight: bold;
  margin-top: 5px;
}
.day-label {
  font-weight: bold;
  font-size: 1rem;
}
.day-icon {
  color: #1959bb !important;
}

.plus-icon {
  cursor: pointer;
  margin-left: 10px;
  color: #1959bb !important;
}
ul li {
  list-style: none !important;
  margin-top: 6px !important;
  padding-left: 0px !important;
}
a {
  color: black !important;
  text-decoration: none !important;
}
.custom-modal h6 {
  color: black !important;
}
.action-buttons {
  text-align: end !important;
  margin: 8px 0px 0px 18px;
}

.action-buttons .submit-button {
  background-color: #003366 !important; /* Dark blue */
  color: white;
  margin-right: 8px; /* Gap between buttons */
  border-color: #003366;
}

.action-buttons .delete-button {
  background-color: #87cefa !important; /* Light blue */
  color: black !important;
  font-weight: 600;
  border-color: #87cefa;
}

@media only screen and (max-width: 480px) {
  .custom-table-div {
    margin: 2px 1px 10px 7px !important;
  }

  .main-card h5 {
    font-size: 15px !important;
    padding-left: 6px !important;
    text-align: start;
    font-weight: bold;
    margin-top: 5px;
  }

  .main-card {
    padding: 5px !important;
  }

  .day-label {
    margin-top: 7px !important;
    margin-bottom: 7px !important;
  }

  .day-label-mb {
    font-size: 14px !important;
  }

  .custom-day-row {
    margin: 12px 0px !important;
  }

  .day-label-mb span {
    font-size: 11.5px !important;
    font-weight: normal !important;
  }

  .custom-timesheet-row {
    padding-left: 0% !important;
    padding-right: 0% !important;
  }

  /* .custom-timesheet-row .row {
    padding-left: 0% !important;
    padding-right: 0% !important;
  } */

  .custom-timesheet-row .row {
    --bs-gutter-x: 0rem !important;
  }

  .mb-timedate {
    font-size: 13px !important;
    padding-left: 15px !important;
    /* min-height: 40px !important; */
  }

  .mb-timedate .row {
    margin-top: -10px !important;
  }

  .format-text-mb h5 {
    font-size: 15px !important;
  }
  .custom-table-div-mb {
    margin: 5px 5px 5px 5px !important;
  }
  .mb-custom-divider {
    background-color: #1959bb !important;
    margin-left: -7px !important;
  }
  .custom-card-mb {
    border-color: #dee5eb !important;
  }
  .action-buttons {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin: 0px 0px 0px 0px;
  }

  .action-buttons .submit-button {
    background-color: #003366 !important; /* Dark blue */
    color: white;
    border-color: #003366;
  }

  .action-buttons .delete-button {
    background-color: #87cefa !important; /* Light blue */
    color: black !important;
    font-weight: 600;
    border-color: #87cefa;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Timesheet/timesheetdetails.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC,EAAE,cAAc;EACpD,YAAY;EACZ,iBAAiB,EAAE,wBAAwB;EAC3C,qBAAqB;AACvB;;AAEA;EACE,oCAAoC,EAAE,eAAe;EACrD,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;;KAGG;;EAEH;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oCAAoC,EAAE,cAAc;IACpD,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,oCAAoC,EAAE,eAAe;IACrD,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;EACvB;AACF","sourcesContent":[".main-card {\n  padding: 10px !important;\n}\n.main-card h5 {\n  padding-left: 5px !important;\n  font-size: 15px !important;\n  text-align: start;\n  font-weight: bold;\n  margin-top: 5px;\n}\n.day-label {\n  font-weight: bold;\n  font-size: 1rem;\n}\n.day-icon {\n  color: #1959bb !important;\n}\n\n.plus-icon {\n  cursor: pointer;\n  margin-left: 10px;\n  color: #1959bb !important;\n}\nul li {\n  list-style: none !important;\n  margin-top: 6px !important;\n  padding-left: 0px !important;\n}\na {\n  color: black !important;\n  text-decoration: none !important;\n}\n.custom-modal h6 {\n  color: black !important;\n}\n.action-buttons {\n  text-align: end !important;\n  margin: 8px 0px 0px 18px;\n}\n\n.action-buttons .submit-button {\n  background-color: #003366 !important; /* Dark blue */\n  color: white;\n  margin-right: 8px; /* Gap between buttons */\n  border-color: #003366;\n}\n\n.action-buttons .delete-button {\n  background-color: #87cefa !important; /* Light blue */\n  color: black !important;\n  font-weight: 600;\n  border-color: #87cefa;\n}\n\n@media only screen and (max-width: 480px) {\n  .custom-table-div {\n    margin: 2px 1px 10px 7px !important;\n  }\n\n  .main-card h5 {\n    font-size: 15px !important;\n    padding-left: 6px !important;\n    text-align: start;\n    font-weight: bold;\n    margin-top: 5px;\n  }\n\n  .main-card {\n    padding: 5px !important;\n  }\n\n  .day-label {\n    margin-top: 7px !important;\n    margin-bottom: 7px !important;\n  }\n\n  .day-label-mb {\n    font-size: 14px !important;\n  }\n\n  .custom-day-row {\n    margin: 12px 0px !important;\n  }\n\n  .day-label-mb span {\n    font-size: 11.5px !important;\n    font-weight: normal !important;\n  }\n\n  .custom-timesheet-row {\n    padding-left: 0% !important;\n    padding-right: 0% !important;\n  }\n\n  /* .custom-timesheet-row .row {\n    padding-left: 0% !important;\n    padding-right: 0% !important;\n  } */\n\n  .custom-timesheet-row .row {\n    --bs-gutter-x: 0rem !important;\n  }\n\n  .mb-timedate {\n    font-size: 13px !important;\n    padding-left: 15px !important;\n    /* min-height: 40px !important; */\n  }\n\n  .mb-timedate .row {\n    margin-top: -10px !important;\n  }\n\n  .format-text-mb h5 {\n    font-size: 15px !important;\n  }\n  .custom-table-div-mb {\n    margin: 5px 5px 5px 5px !important;\n  }\n  .mb-custom-divider {\n    background-color: #1959bb !important;\n    margin-left: -7px !important;\n  }\n  .custom-card-mb {\n    border-color: #dee5eb !important;\n  }\n  .action-buttons {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    margin: 0px 0px 0px 0px;\n  }\n\n  .action-buttons .submit-button {\n    background-color: #003366 !important; /* Dark blue */\n    color: white;\n    border-color: #003366;\n  }\n\n  .action-buttons .delete-button {\n    background-color: #87cefa !important; /* Light blue */\n    color: black !important;\n    font-weight: 600;\n    border-color: #87cefa;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
